const DB_NAME = "DashboardCacheDB";
const DB_VERSION = 1;
const SPORT_DATA_STORE_NAME = "sportData";
const HORSE_RACING = "horse-racing";
const MARKET_BY_COUNTRY_CODE = "market-by-country-code";
const SPORT_SERIES_STORE = "sport-series";

// Open IndexedDB and create stores if they don't exist
const openDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = () => reject("Error opening IndexedDB");

    request.onsuccess = () => resolve(request.result);

    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;

      if (!db.objectStoreNames.contains(SPORT_DATA_STORE_NAME)) {
        db.createObjectStore(SPORT_DATA_STORE_NAME, { keyPath: "key" });
      }

      if (!db.objectStoreNames.contains("sport-series")) {
        db.createObjectStore("sport-series", { keyPath: "key" });
      }
      if (!db.objectStoreNames.contains(HORSE_RACING)) {
        db.createObjectStore(HORSE_RACING, { keyPath: "key" });
      }
      if (!db.objectStoreNames.contains(MARKET_BY_COUNTRY_CODE)) {
        db.createObjectStore(MARKET_BY_COUNTRY_CODE, { keyPath: "key" });
      }
      if (!db.objectStoreNames.contains(SPORT_SERIES_STORE)) {
        db.createObjectStore(SPORT_SERIES_STORE, { keyPath: "key" });
      }
    };
    request.onerror = () => reject("Error opening IndexedDB");

    request.onsuccess = () => resolve(request.result);
  });
};

export const getSportDataDB = async (key: string): Promise<any> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db?.transaction(SPORT_DATA_STORE_NAME, "readonly");
    const store = transaction.objectStore(SPORT_DATA_STORE_NAME);
    const request = store.get(key);

    request.onsuccess = () => {
      const data = request.result;
      const now = Date.now();
      if (data && now - data.timestamp < 2 * 60 * 60 * 1000) {
        // Cache expiration time (2 hours)
        resolve(data.value);
      } else {
        resolve(null); // Cache expired or no data
      }
    };

    request.onerror = () => reject("Error reading from sportData cache");
  });
};

// Save data to sportData store
export const setSportDataDB = async (
  key: string,
  value: any
): Promise<void> => {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const transaction = db?.transaction(SPORT_DATA_STORE_NAME, "readwrite");
    const store = transaction.objectStore(SPORT_DATA_STORE_NAME);
    const request = store.put({ key, value, timestamp: Date.now() });

    request.onsuccess = () => resolve();
    request.onerror = () => reject("Error saving to sportData cache");
  });
};

export const getSportSeriesDataDB = async (key: string): Promise<any> => {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const transaction = db.transaction(SPORT_SERIES_STORE, "readonly");
    const store = transaction.objectStore(SPORT_SERIES_STORE);
    const request = store.get(key);

    request.onsuccess = () => {
      const data = request.result;
      const now = Date.now();
      if (data && now - data.timestamp < 2 * 60 * 60 * 1000) {
        resolve(data.value);
      } else {
        resolve(null);
      }
    };

    request.onerror = () => reject("Error reading from sport-series cache");
  });
};

export const setSportSeriesDataDB = async (
  key: string,
  value: any
): Promise<void> => {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const transaction = db.transaction(SPORT_SERIES_STORE, "readwrite");
    const store = transaction.objectStore(SPORT_SERIES_STORE);
    const request = store.put({ key, value, timestamp: Date.now() });

    request.onsuccess = () => resolve();
    request.onerror = () => reject("Error saving to sport-series cache");
  });
};

export const getHorseRacingDataDB = async (key: string): Promise<any> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db?.transaction(HORSE_RACING, "readonly");
    const store = transaction.objectStore(HORSE_RACING);
    const request = store.get(key);

    request.onsuccess = () => {
      const data = request.result;
      const now = Date.now();
      if (data && now - data.timestamp < 2 * 60 * 60 * 1000) {
        resolve(data.value);
      } else {
        resolve(null);
      }
    };

    request.onerror = () => reject("Error reading from horse-racing cache");
  });
};

export const setHorseRacingDataDB = async (
  key: string,
  value: any
): Promise<void> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db?.transaction(HORSE_RACING, "readwrite");
    const store = transaction.objectStore(HORSE_RACING);
    const request = store.put({ key, value, timestamp: Date.now() });

    request.onsuccess = () => resolve();
    request.onerror = () => reject("Error saving to horse-racing cache");
  });
};
export const getMarketByCountryCodeDB = async (key: string): Promise<any> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db?.transaction(MARKET_BY_COUNTRY_CODE, "readonly");
    const store = transaction.objectStore(MARKET_BY_COUNTRY_CODE);
    const request = store.get(key);

    request.onsuccess = () => {
      const data = request.result;
      const now = Date.now();
      if (data && now - data.timestamp < 2 * 60 * 60 * 1000) {
        resolve(data.value);
      } else {
        resolve(null);
      }
    };

    request.onerror = () => reject("Error reading from horse-racing cache");
  });
};

export const setMarketByCountryCodeDB = async (
  key: string,
  value: any
): Promise<void> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db?.transaction(MARKET_BY_COUNTRY_CODE, "readwrite");
    const store = transaction.objectStore(MARKET_BY_COUNTRY_CODE);
    const request = store.put({ key, value, timestamp: Date.now() });

    request.onsuccess = () => resolve();
    request.onerror = () => reject("Error saving to horse-racing cache");
  });
};
